module.exports = __webpack_public_path__ + "monster.d5c0cccc.png";